var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9997 20.0783C9.39312 20.0783 7.81201 19.6507 6.42892 18.8424C6.20624 18.7122 5.9381 18.6775 5.68922 18.7453L2.68186 19.5705L3.72977 17.2628C3.87232 16.9492 3.83534 16.5832 3.63423 16.3035C2.51312 14.7509 1.92135 12.9163 1.92135 11C1.92135 5.99391 5.99357 1.92169 10.9997 1.92169C16.0058 1.92169 20.078 5.99391 20.078 11C20.078 16.0061 16.0058 20.0783 10.9997 20.0783ZM10.9997 0C4.9341 0 0.000437901 4.93444 0.000437901 11C0.000437901 13.1336 0.605299 15.1824 1.75723 16.9608L0.0859661 20.6416C-0.0681387 20.9814 -0.0118904 21.379 0.229284 21.6625C0.41498 21.879 0.683893 22 0.960511 22C1.58001 22 4.95876 20.9382 5.81866 20.7017C7.40825 21.5523 9.19048 22 10.9997 22C17.0645 22 21.9997 17.0648 21.9997 11C21.9997 4.93444 17.0645 0.000770524 10.9997 0Z",
    fill: "#4AF884"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6257 12.2861C13.2096 12.4564 12.9438 13.1082 12.6741 13.4411C12.5354 13.6114 12.3705 13.6384 12.1578 13.5528C10.5952 12.9302 9.39704 11.887 8.53482 10.4492C8.38842 10.2265 8.41462 10.05 8.59107 9.84276C8.85151 9.53609 9.17898 9.18781 9.2491 8.77404C9.40551 7.8602 8.21043 5.0239 6.63163 6.30913C2.08939 10.0107 14.209 19.828 16.3965 14.5183C17.0152 13.0127 14.3161 12.0033 13.6257 12.2861Z",
    fill: "#4AF884"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsicon);
export default __webpack_public_path__ + "static/media/whatsicon.41ca8acfead603c2305d1d9fba3f7ada.svg";
export { ForwardRef as ReactComponent };